import DataTableHeader from "./DataTableHeader";
import DataTableRows from "./DataTableRows";
import PropTypes from "prop-types";
import React from "react";

class SimpleDataTable extends React.Component {
  render() {
    // console.log(this.props.definitions.TABLE);
    let tableWrapClassName = "data-table-wrap";
    if (this.props.definitions.TABLE.className) {
      tableWrapClassName += ` ${this.props.definitions.TABLE.className}`;
    }
    if (this.props.className) {
      tableWrapClassName += ` ${this.props.className}`;
    }
    return (
      <div className={`${tableWrapClassName} ${this.props.className || ""}`}>
          <div className="data-table-scrollbox">
            <div className="data-table">
              <DataTableHeader
                colDefs={this.props.definitions.COLUMN}
                customTableProps={{
                  ...this.props.customTableProps,
                  rowsData: this.props.rowsData,
                  colDefs: this.props.definitions.COLUMN,
                }}
              />
              <DataTableRows
                rowsData={this.props.rowsData}
                colDefs={this.props.definitions.COLUMN}
                customTableProps={{
                  ...this.props.customTableProps,
                }}
              />
            </div>
          </div>
      </div>
    );
  }

  static propTypes = {
    className: PropTypes.string,
    rowsData: PropTypes.array,
    definitions: PropTypes.shape({
      TABLE: PropTypes.object.isRequired,
      COLUMN: PropTypes.array.isRequired
    }).isRequired,
    customTableProps: PropTypes.object,
    onChangeRowSelect: PropTypes.func
  };
}

export default SimpleDataTable;
